import { render } from "./Draggable.svg?vue&type=template&id=39371aa0"
const script = {}
script.render = render

export default script